// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fapyTRtxUhHwJoMFYSFq {
  width: 100%;
}
.KXip7X1o2D2wRLXhhWJp {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: inline-block;
  width: 100px;
}
.GPFxJCFrJmUF3GHGaN_g {
  color: red;
}
.IJfeRcOUrbCAIIvsAPPG {
  color: #1677ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/common/NozzleTable/styles.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAEA;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AAAF;AAGA;EACE,UAAA;AADF;AAGA;EACE,cAAA;AADF","sourcesContent":[".editableDiv {\n  width: 100%;\n}\n\n.totalFraction {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  display: inline-block;\n  width: 100px;\n}\n\n.errorStatus {\n  color: red;\n}\n.manualInputRow {\n  color: #1677ff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editableDiv": `fapyTRtxUhHwJoMFYSFq`,
	"totalFraction": `KXip7X1o2D2wRLXhhWJp`,
	"errorStatus": `GPFxJCFrJmUF3GHGaN_g`,
	"manualInputRow": `IJfeRcOUrbCAIIvsAPPG`
};
export default ___CSS_LOADER_EXPORT___;
